import { render } from "./NYFormFailed.vue?vue&type=template&id=97523fe6&scoped=true"
import script from "./NYFormFailed.vue?vue&type=script&lang=js"
export * from "./NYFormFailed.vue?vue&type=script&lang=js"

import "./NYFormFailed.vue?vue&type=style&index=0&id=97523fe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97523fe6"]])

export default __exports__